import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';

import Section from '../../../../../components/Section';
import styles from './Results.scss';


class Results extends PureComponent {
	static renderWinner(winner, props) {
		const style = {
			...(props.theming['studio.styles.quiz.winners'] || {}),
		};
		if (winner.username && winner.name) {
			return (
				<div className={styles.name} style={style}>
					{`${winner.username} (${winner.name})`}
				</div>
			);
		}
		return (
			<div className={styles.name} style={style}>
				{winner.username || winner.firstName || winner.name}
			</div>
		);
	}

	render() {
		const {
			locale, count, winners, prizePerUser = 0, quizConfig, theming,
		} = this.props;

		const value = isNil(prizePerUser) ? '0' : prizePerUser.toFixed(this.props.fractionalDigits);
		return (
			<Section>
				<Section.Heading>{locale.winners}</Section.Heading>
				<div className={styles.root}>
					<p>{locale['winners.count']}</p>
					<p>{count}</p>
					<p>{locale['prize.per.user']}</p>
					<p>
						{quizConfig.valuta}
						{value}
					</p>
					{winners && winners.map(w => Results.renderWinner(w, { theming }))}
				</div>
			</Section>
		);
	}
}

Results.propTypes = {
	count: PropTypes.number,
	fractionalDigits: PropTypes.number,
	theming: PropTypes.shape.isRequired,
};

Results.defaultProps = {
	fractionalDigits: 2,
};

export default Results;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quiz/children/results/Results.component.js